import Vue from 'vue';

export default class Api {
  constructor(gqlClient) {
    this.gqlClient=gqlClient;
  }

  async userFromToken(token) {
    if (!token) return;
    const q=`
      query userFromToken($token: String) {
        userFromToken(token: $token) { 
          user_id username email first_name last_name fullName
          account_id control_account_id msg_group_id
          SMSFromNumbers {
            number
            entity_id
            entity_type
            entity_name
          }
        }
      }
    `;
    return (await this.gqlClient.request(q, { token })).userFromToken;
  }

  async myConferences() {
    const conferencesQryTxt = `
          query root {
              usersForMessaging {
                  username
                  password
                  first_name
                  last_name
                  user_id
                  msg_group_id
              } 
              myConferences {
                  conference_id
                  name
                  user_id
                  conference_type
                  record
                  transcribe
                  email_address
                  instant
                  share_with_account
                  pins {
                      pin
                      is_admin
                      is_active
                      token
                      url_token
                      require_pin_as_password
                  }
                  users {
                      user_id
                      first_name
                      last_name
                      user_id
                      username
                  }
                  ActiveSession {
                    conference_session_id
                    conference_id
                    start_time
                    end_time
                  }
                  Participants {
                    conference_session_participant_id
                    conference_session_id
                    name
                    email
                    phone_number
                    start_time
                    end_time
                    token
                    is_caller
                    is_admin
                    is_rinble_phone
                    is_muted
                    bill_minutes
                    bill_rate
                    asterisk_uniqueid
                    asterisk_channel
                  }
              }
          }
    `;
    let confQry = global.gql(conferencesQryTxt);
    return await global.apollo.query({ query: confQry, fetchPolicy: 'network-only' });
  }


  async myQueues() {
    const queuesQryTxt = `
          query root {
              myQueues {
                  ast_queue_id
                  name
                  account_id
                  timeout
                  musiconhold
                  musicclass
                  strategy
                  joinempty
                  leavewhenempty
                  extension
                  timezone
                  ring_for_caller
                  cname_to_queue_name
                  callername_prefix
                  msg_group_id
                  QueueSupervisors {
                    queue_supervisor_id
                    ast_queue_id
                    user_id
                    name
                    dated
                  }
                  AstQueueDevices {
                    ast_queue_device_id
                    device_id
                    device_name
                    device_status
                    ast_queue_id
                    ringinuse
                    paused
                    Sipdevices { 
                      sipdevice_id
                      device_id
                      name
                      device_type
                      Ringinuse
                      Paused
                      Status
                      PausedReason
                      InCall
                    }
                  }
              }
          }
    `;
    let queuesQry = global.gql(queuesQryTxt);
    return await global.apollo.query({ query: queuesQry, fetchPolicy: 'network-only' });
  }


  // get queue stats for a given queue
  async queueStats(queueId) {
    const queueStatsQryTxt = `
          query queueStatsQry($ast_queue_id: Int!) {
              queueStats(ast_queue_id: $ast_queue_id) {
                  ast_queue_id
                  callers
                  abandoned
                  answered
                  longest_hold_time
                  avg_hold_time
                  avg_talk_time
              }
          }
    `;
    let variables = {ast_queue_id: queueId}
    let queueStatsQry = global.gql(queueStatsQryTxt);
    return await global.apollo.query({ query: queueStatsQry, variables, fetchPolicy: 'network-only' });
  }

  async confrenceFromUrlToken(token, pin) {
    const conferenceQryTxt = `
          query conferenceByUrlTokenQry($token: String!, $pin: String) {
              conferenceByUrlToken(token: $token, pin: $pin) {
                  conference_id
                  name
                  user_id
                  conference_type
                  record
                  transcribe
                  email_address
                  instant
                  share_with_account
                  pins {
                      pin
                      is_admin
                      is_active
                      token
                      url_token
                      require_pin_as_password
                  }
                  users {
                      user_id
                      first_name
                      last_name
                      user_id
                      username
                  }
                  ActiveSession {
                    conference_session_id
                    conference_id
                    start_time
                    end_time
                  }
                  Participants {
                    conference_session_participant_id
                    conference_session_id
                    name
                    email
                    phone_number
                    start_time
                    end_time
                    token
                    is_caller
                    is_admin
                    is_rinble_phone
                    is_muted
                    bill_minutes
                    bill_rate
                    asterisk_uniqueid
                    asterisk_channel
                  }
              }
          }
    `;
    if (!pin) pin = ""; // have to send a string
    let variables = {token: token, pin: pin}
    let confQry = global.gql(conferenceQryTxt);
    let result = await global.apollo.query({ query: confQry, variables, fetchPolicy: 'network-only' });
    if (result.data.conferenceByUrlToken) {
      return result.data.conferenceByUrlToken;
    }
    return null;
  }

  async devices() {
    const q=`
      query devices {
        devices { device_id nickname click2call_token user_id parent_device_id pairing_strategy type login secret sipserver}
      }
    `;

    return (await this.gqlClient.request(q)).devices;
  }


  async guestConferenceUserDevice(urlToken) {
    const q=`
      query deviceForGuestConferenceUserQry($urlToken: String!) {
        deviceForGuestConferenceUser(urlToken: $urlToken) { device_id nickname click2call_token user_id parent_device_id pairing_strategy type login secret sipserver}
      }
    `;

    let variables = {urlToken: urlToken}
    let qry = global.gql(q);
    let result = await global.apollo.query({ query: qry, variables, fetchPolicy: 'network-only' });
    if (result.data.deviceForGuestConferenceUser) {
      return result.data.deviceForGuestConferenceUser;
    }
    return null;
  }
  

  async addFirebaseToken(token) {
    if(!token) return;
    const q=`
      mutation addFirebaseToken($token: String!) {
        addFirebaseToken(token: $token)
      }
    `;

    return (await this.gqlClient.request(q, {token}));
  }

  async delFirebaseToken(token) {
    if(!token) return;
    const q=`
      mutation delFirebaseToken($token: String!) {
        delFirebaseToken(token: $token)
      }
    `;
    return (await this.gqlClient.request(q, {token}));
  }

  async lineKeys(click2CallToken, deviceId) {
      let response = await Vue.http.get(
                                          global.apiurl + "/device/linekeys" +
                                            "&c2cToken=" + encodeURIComponent(click2CallToken) +
                                            "&deviceId=" + deviceId
                                        );
      return response.data.data;
  }

  async deleteLineKey(lk, device) {
    const self = this;
    let response = await Vue.http.post(
                            global.apiurl + "/device/deletelinekey",
                              {
                                c2cToken: encodeURIComponent(device.click2call_token),
                                deviceId: device.device_id,
                                lineKeyId: lk.line_key_id
                              }
                          );
                  
    let data = response.data;
    if (data.message == "ok") {
        return data.lineKeys;
    }
  }

  async addLineKey(label, userServiceId, pickup, subscribe, monitor, deviceId, c2cToken) {
    let self = this;
    // console.log(label);
    if (label) {
      let data = {
        user_service_id: userServiceId,
        pickup: pickup,
        subscribe: subscribe,
        monitor: monitor,
        deviceId: deviceId,
        c2cToken: encodeURIComponent(c2cToken),
      };
      // console.log(data);
      let response = await Vue.http.post(
                                    global.apiurl + '/device/addlinekey',
                                    data
                                  );
      // console.log(response)
      let retdata = response.data;
      if (retdata.message == "ok") {
        //self.$dialog.alert('Lin');
        return retdata.lineKey;
      } else {
        return null;
      }
    }
  }

  async addCustomLineKey(label, number, deviceId, c2cToken) {
    let self = this;
    if (label) {
      let data = {
        override: 'Y',
        pickup: 'N',
        subscribe: 'N',
        monitor: 'N',
        overrideLabel: label,
        overrideNumber: number.replace(/-/g, '').replace(/\+1 \(/,'').replace(/\)/,''),
        deviceId: deviceId,
        c2cToken: encodeURIComponent(c2cToken),
      }
      let response = await Vue.http.post(
                                          global.apiurl + '/device/addlinekey',
                                          data
                                        );
      let retdata = response.data;
      if (retdata.message == "ok") {
        return retdata.lineKey;
      } else {
        return null;
      }
    }
  }

  async callHistory(click2call_token) {
    let response = await Vue.http.get(global.apiurl + "/mobile-call-history&token=" + click2call_token);
    return response.body.data;
  }

  async userAction(action, item, itemType) {
    let uaTxt = `
      mutation userAction($input: UserActionInput) {
        userAction(input: $input) {
          user_id,
          action,
          date
        }
      }
    `;
    let variables = {
      input: {
        action: action,
        item: item,
        item_type: itemType
      }
    }
    return (await this.gqlClient.request(uaTxt, variables));
  }

}

